import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'
import { BaseService } from './base'

class AutoTicketServiceClass {
    getDetail(ticketId) {
        return BaseService.get(APIPath.autoTicketGet(ticketId))
    }

    getByAudit(auditId) {
        return BaseService.get(APIPath.autoTicketByAudit(auditId))
    }

    addComment(ticketId, text) {
        return BaseService.post(APIPath.autoTicketComment(ticketId), { text })
    }

    acknowledge(ticketId, note) {
        return BaseService.post(APIPath.autoTicketAcknowledge(ticketId), {
            note: note || undefined,
        })
    }

    resolve(ticketId, note) {
        const text = note || undefined
        return BaseService.post(APIPath.autoTicketResolve(ticketId), {
            note: text,
            Resolution: text,
        })
    }

    close(ticketId, note) {
        return BaseService.post(APIPath.autoTicketClose(ticketId), {
            note: note || undefined,
        })
    }

    reassign(ticketId, { assignedToTypeId, assignedToId, note }) {
        return BaseService.post(APIPath.autoTicketReassign(ticketId), {
            assignedToTypeId: Number(assignedToTypeId),
            assignedToId: Number(assignedToId),
            note: note || undefined,
        })
    }

    getAssignableUsers(queryParams = {}) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.autoTicketAssignableUsers}?${params}`)
    }

    getCompanySetting() {
        return BaseService.get(APIPath.autoTicketCompanySetting)
    }

    saveCompanySetting({ notificationMode, releaseOn }) {
        return BaseService.post(APIPath.autoTicketCompanySetting, {
            NotificationMode: Number(notificationMode),
            ReleaseOn: Number(releaseOn),
        })
    }

    cancel(ticketId, reason) {
        return BaseService.post(APIPath.autoTicketCancel(ticketId), {
            Reason: reason,
        })
    }

    // New reopen route from the approval API collection.
    reopen(ticketId, reason) {
        return BaseService.post(APIPath.actionPlanTicketReopen(ticketId), {
            Reason: reason,
        })
    }

    releaseAudit(auditId) {
        return BaseService.post(APIPath.autoTicketRelease(auditId), {})
    }

    getTickets(queryParams = {}) {
        const params = CommonUtility.objectToParams(queryParams)
        const query = params ? `?${params}` : ''
        return BaseService.get(`${APIPath.tickets}${query}`)
    }

    getMagicDetail(token) {
        return BaseService.get(APIPath.autoTicketMagicGet(token), false)
    }

    addMagicComment(token, text) {
        return BaseService.post(
            APIPath.autoTicketMagicComment(token),
            { text },
            false,
        )
    }

    getDigest(token) {
        return BaseService.get(APIPath.autoTicketDigestGet(token), false)
    }
}

export const AutoTicketService = new AutoTicketServiceClass()
